import { useState } from "react";
import TextareaField from "../../../../components/form/textarea"
import MiniModal from "../../../../components/modal/mini-modal"
import Button from "../../../../components/form/button";

const FlagReasonModal = ({ open, onClose, submitReason, submitting }: { open: boolean, onClose: () => void, submitReason: (reason: string) => void, submitting?: boolean }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');
    const validate = () => {
        if (reason.length == 0) {
            setError('The reason is required.');
            return;
        }
        if (reason.length < 10) {
            setError('The reason must be at least 10 characters long.');
            return;
        }
        submitReason(reason)
    }
    return (
        <MiniModal open={open} setClose={onClose} title="Flag an issue">
            <div className="grid gap-4">
                <div>
                    <TextareaField
                        value={reason}
                        label="Reason for flagging"
                        onChangeInput={(e) => {
                            setReason(e.target.value);
                            setError('');
                        }}
                        error={error}
                    />
                </div>
                <div className="flex gap-4 flex-wrap">
                    <Button isLoading={submitting} text="Submit" onClick={validate} />
                    <Button disabled={submitting} design="primary-danger-outline" text="Cancel" onClick={onClose} />
                </div>
            </div>
        </MiniModal>
    )
}

export default FlagReasonModal